import request from '@/utils/request'

let CampusApi = {

  /*校区列表*/
  list(data) {
    return request._post('/shop/plus.campus.Index/index', data);
},
/*添加校区*/
add(data) {
    return request._post('/shop/plus.campus.Index/add', data);
},
/*修改校区*/
edit(data) {
    return request._post('/shop/plus.campus.Index/edit', data);
},
/*删除校区*/
del(data) {
    return request._post('/shop/plus.campus.Index/del', data);
},
/*校区详情*/
detail(data) {
  return request._post('/shop/plus.campus.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.campus.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.campus.Setting/getSetting', data, errorback);
    },
}
export default CampusApi;



// WEBPACK FOOTER //
// ./src/api/campus.js